// extracted by mini-css-extract-plugin
module.exports = {"main-page-title":"MainPageTitle_main-page-title__WpPUz","icons":"MainPageTitle_icons__46UqX","active-cart-link":"MainPageTitle_active-cart-link__89Z25"};